export default function cx(...args) {
	let out = '';
	for (const arg of args) {
		if (out) out += ' ';
		if (arg) out += arg;
	}
	return out;
}
